import {Component, Input} from '@angular/core';
import {Accusation, Player, Project} from '../../../../core/models';
import {PlayerService} from '../../../../core/services/project-player.service';

@Component({
  selector: 'app-project-accusation-details',
  templateUrl: './accusation-details.component.html'
})
export class AccusationDetailsComponent {
  @Input() accusation: Accusation;
  @Input() project: Project;
  @Input() player: Player;

  constructor(private playerService: PlayerService) {
  }

  downloadEvidence() {
    this.playerService.getAccusationDownloadEvidence(this.player.id, this.accusation.id);
  }


}
